/**
 * Disabling the danger rule in this file cause no harm cause the html
 * that we're working on is sanitized
 *
 * For more information see:
 * https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-danger.md
 */
/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import cts from '../../app/cts';
import apis from '../../app/apis';
import { BackButton, Drawer } from '../../components';

import { Loading, Title } from './components';
import EventTracker from '../../helpers';

const Container = styled.div`
  overflow: auto;
  height: auto;
`;

const ContentContainer = styled.div`
  padding: 10px 20px;
  box-sizing: border-box;

  p {
    font-size: 15px !important;
    font-weight: 500 !important;
    display: block;
    line-height: 24px !important;
    color: #404040 !important;
    text-indent: 25px;
    font-family: Montserrat !important;

    a {
      all: initial;
      display: inline;
      font-family: Montserrat !important;
      color: #0086C2 !important;
      font-weight: bold !important;
      font-size: 16px !important;
      text-decoration: none !important;
      cursor: pointer;
      border-bottom: 1px solid transparent !important;
      padding-bottom: 3px !important;
  
      &:hover{
        color: #11A9CE !important;
        border-bottom: 1px solid #11A9CE !important;
        padding-bottom: 3px !important;
      }
  
    }
  }

  section, div {
    margin-bottom: 15px;
    display: block;

    ul {
      list-style: disc;
      padding-left: 35px;
      margin-top: -15px;
      line-height: 2em !important;

      li {
        all: initial;
        list-style: disc;
        font-size: 15px !important;
        line-height: 24px !important;
        font-weight: 500 !important;
        color: #404040 !important;
        display: block;
        font-family: Montserrat !important;
      }
    }
  }

  a {
    all: initial;
    border: none;
    text-align: center;
    cursor: pointer;
    display: block;
    margin: 10px auto;
    font-family: inherit !important;
    background-color: transparent;
    font-weight: bold !important;
    text-decoration: none;
    font-size: 16px !important;
    color: #0086C2;
    border-bottom: 1px solid transparent;
    padding-bottom: 3px;

    &::-moz-focus-inner {
      border: 0;
    }

    &:hover{
      color: #11A9CE;
      border-bottom: 1px solid #11A9CE;
      padding-bottom: 3px;
    }
  }

  title {
    display: block;
    margin: 15px 0;
    font-size: 20px !important;
  }

`;

const GeneralContent = styled.div`
  marginTop: 30;
  marginBottom: 30;
  border: 0;
  &::-moz-focus-inner {
    border: 0;
  }
`;


const GeneralPage = ({ districtId, localityId, location }) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const { link } = location.state;

  useEffect(() => {
    const getPage = async () => {
      try {
        setLoading(true);
        const { data } = await cts('get', apis.getGeneralPage(localityId, link));
        if (!Object.keys(data.content.response).length) {
          throw new Error('Could not get general page data');
        }
        setContent({
          data: data.content.response.pageDetails.page_content,
          links: data.content.response.pageDetails.links,
          title: data.content.response.pageDetails.page_bar_title,
          pageImage: data.content.response.pageDetails.page_image
        });
      } catch (e) {
        setContent({});
      } finally {
        setLoading(false);
      }
    };
    getPage();
  }, [link, localityId]);


  useEffect(() => {
    let value = link;
    if (value.includes('gpg/')) value = value.replace('gpg/', '');
    if (value.includes('.page')) value = value.replace('.page', '');
    EventTracker('CMS - General Page', value);
  }, [link, localityId, districtId]);

  return (
    <Container>
      <BackButton />
      {
        loading
          ? (
            <Loading />
          ) : null
      }
      {
        Object.keys(content).length
          ? (
            <div>
              <Title>{content.title}</Title>
              <ContentContainer>
                <div dangerouslySetInnerHTML={{ __html: content.data }} />
                {
                  content.links.length
                    ? (
                      <GeneralContent tabIndex="-1">
                        {
                          content.links.map((lnk) => (
                            <Drawer
                              key={lnk.drawer_title}
                              link={lnk}
                            />
                          ))
                        }
                      </GeneralContent>
                    ) : null
                }
              </ContentContainer>
            </div>
          ) : null
      }
    </Container>
  );
};

export default withRouter(connect((state) => ({
  localityId: state.app.localityId,
  districtId: state.app.districtId
}))(GeneralPage));
